module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/babel-runtime/core-js/object/assign.js
// module id = 821
// module chunks = 0